import { Account } from '@liquidbudget/common';
import { DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { toast } from '@/components/ui/toast/use-toast';
import { AccountDeleteForm } from './account-delete-form';
import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
  account: Account;
  onClose: () => void;
}

export function AccountDeleteDialog({ account, onClose }: Props) {
  const location = useLocation();
  const navigate = useNavigate();

  const onSuccess = () => {
    onClose();

    // Check if we're on the deleted account's route
    if (location.pathname.includes(`/account/${account.id}`)) {
      navigate(`/budget/${account.budgetId}/account`);
    }

    toast({
      title: 'Success',
      description: 'Your account has been deleted',
    });
  };

  return (
    <DialogContent onInteractOutside={(e) => e.preventDefault()}>
      <DialogHeader>
        <DialogTitle>Delete {account?.name}</DialogTitle>
      </DialogHeader>
      <DialogDescription>
        This will permanently delete this account and all associated transactions, which may throw your assignments out
        of balance. Please double check before you delete as this is an irreversible action!
      </DialogDescription>
      <AccountDeleteForm account={account} onSuccess={onSuccess} />
    </DialogContent>
  );
}
